
/**
 * config = {
 *  x: number,
 *  y: number
 * }
 */

G.UI_DailyChallengeIcon = function(config) {
  this.state = game.state.getCurrentState();

  Phaser.Group.call(this,game);

  const unlockAtLvl = G.featureUnlock.unlockLevels.dailyChallenge;
  this.unlocked = G.saveState.getLastPassedLevelNr() >= unlockAtLvl;
  let dailyChallengeIconContainer = new Phaser.Group(game);

  this._config = config || {};
  this.ignorePosition = !(this._config.x || this._config.y);
  if (!this.ignorePosition) {
    this.x = G.l(x);
    this.y = G.l(y);
  }

  this.glow = G.makeImage(0, 0,'popup_lighht',0.5, dailyChallengeIconContainer);
  this.glow.alpha = 0.5;
  this.glow.scale.setTo(0.5);
  this.glow.blendMode = 1;
  this.glow.update = function(){this.angle++};

  // launch challenge button
  let importantContainer = new Phaser.Group(game);
  dailyChallengeIconContainer.add(importantContainer);
  this.icon = new G.Button(0, 0,'btn_daily_challenge', this._onDailyChallengeIconClick, this);

  this.icon.adIcon = G.makeImage(30,20,"video_wheel_menu", 0.5, this.icon);
  game.add.tween(this.icon.adIcon.scale)
    .to({x: 1.2, y: 1.2}, 1000, Phaser.Easing.Sinusoidal.InOut,true, 0, -1, true);
  this.icon.adIcon.angle = -4;
  game.add.tween(this.icon.adIcon)
    .to({angle: 4}, 2000, Phaser.Easing.Sinusoidal.InOut,true,0,-1, true);

  importantContainer.add(this.icon);

  this.freeText = new G.Text(5, 65, OMT.language.getText('Daily Challenge'), "ui-dailyChallenge",0.5,150,150, true, 'center');
  this.freeText.inputEnabled = true;
  this.freeText.input.useHandCursor = true;
  this.freeText.events.onInputDown.add(this._onDailyChallengeIconClick, this);
  this.freeText.lineSpacing = -10;
  this.freeText.setShadow(0, 0, 'black', 3);
  importantContainer.add(this.freeText);

  this.add(dailyChallengeIconContainer);

  game.add.tween(this.freeText.scale).to({x:0.9,y:0.9},500,Phaser.Easing.Sinusoidal.InOut,true,0,-1,true);

  this.checkAvailability();

  if (!this.ignorePosition) {
    G.sb("onScreenResize").add(this.onResize,this);
    this.onResize();
  }

  var lastLevelData = this.state.lastLevelData;
  if (lastLevelData && lastLevelData.challenge) {
    this.visible = true;
    this.glow.visible = true;
    this.postFlow = true;
    this.icon.inputEnabled = false;
    game.time.events.add(1000, function() {
      game.add.tween(this.scale)
        .to({x: [0.8, 1], y: [0.8, 1]}, 300, Phaser.Easing.Sinusoidal.Out, true);
      this.batchesWaitingForFinish = 0;
      this._createParticlesBatch(lastLevelData);
      this.icon.inputEnabled = true;
    }, this);

    OMT.transactionTracking.logInventoryTransactionBegin();
    OMT.transactionTracking.addInventoryChange('coins', 0, lastLevelData.reward);
    OMT.transactionTracking.logInventoryTransactionEnd();
  }
};

G.UI_DailyChallengeIcon.prototype = Object.create(Phaser.Group.prototype);

G.UI_DailyChallengeIcon.prototype.update = function() {
  this.glow.angle++;
  this.checkAvailability();
};

G.UI_DailyChallengeIcon.prototype.checkAvailability = function() {
  // comenting was needed to hide the daily challenge icon when the challenge was completed
  //if (this.postFlow) return;

  if (this.unlocked && (OMT.feature.rewardedAdsAvailable() || G.saveState.isChallengeAvailable())) {
    
    if (G.saveState.isChallengeAvailable()) {
      this.available = true;
      this.freeText.visible = this.glow.visible =  true;
      this.icon.adIcon.visible = false;
      this.visible = true;
    } else {
      this.freeText.visible = this.glow.visible =  false;
      this.icon.adIcon.visible = true;
      this.available = false;
      this.visible = true;
      // moved check to update was buggy
      // game.time.events.add(5000, this.checkAvailability, this);
    }
  } else {
    if (this.visible) { //Don't spam this too much, coming from update
      this.freeText.visible = this.glow.visible =  false;
      this.icon.adIcon.visible = false;
      this.available = false;
      this.visible = false;
    }
    // moved check to update was buggy
    //game.time.events.add(5000, this.checkAvailability, this);
  }

};

G.UI_DailyChallengeIcon.prototype.onResize = function(){
  var center = game.world.bounds.x+Math.floor(game.width*0.5);
  this.x = center + G.OMTsettings.elements.dailyChallengeIcon.xCenterOffset;
  this.y = G.OMTsettings.elements.dailyChallengeIcon.y;
};

G.UI_DailyChallengeIcon.prototype._createParticlesBatch = function(lastLevelData){
  if (lastLevelData.starImprovement > 0){
    this._afterLvlPartBatch(lastLevelData.lvlNr,lastLevelData.starImprovement,'stars')
  }

  if (lastLevelData.reward > 0){
    this._afterLvlPartBatch(lastLevelData.lvlNr,lastLevelData.reward,'coins')
  }
};

G.UI_DailyChallengeIcon.prototype._afterLvlPartBatch = function(lvlNr,amount,objType){

  // set the coin display to value before level reward was added
  let coinsAdded = 0;
  G.sb('onCoinsChange').dispatch(G.saveState.getCoins() - amount);

  let coins = objType == 'coins';
  var state = game.state.getCurrentState();

  let batch = this.state.uiTargetParticlesBW.createDividedBatch(
    game.world.bounds.x+this.worldPosition.x,
    this.worldPosition.y,
    coins ? 'coin_1' : 'map_star_1',
    coins ? this.state.panel.coinsTxt : this.state.panel.starsTxt,
    amount,
    coins ? 3 : 1);

  batch.addOnPartStart(function(particle) {
    if (coins) {
      particle.scale.setTo(0.9);
    } else {
      particle.scale.setTo(1.2);
    }
    particle.speedDelta = 0.5;
    particle.speedMax = 20;
    particle.vel.x = game.rnd.realInRange(-20,20);
    particle.vel.y = game.rnd.realInRange(-20,20);
  });

  batch.addOnPartFinish(function(particle) {
    G.sfx.pop.play();
    if (coins) {
      coinsAdded += particle.carriedValue;
      // update the coin display, but dont actually add anything
      G.sb('onCoinsChange').dispatch((G.saveState.getCoins() - amount) + coinsAdded);
    }else{
      var starsTxt = state.panel.starsTxt;
      starsTxt.setText(parseInt(starsTxt.text)+1);
    }
  });

  this.batchesWaitingForFinish++;

  batch.onFinish.add(function(){
    this.batchesWaitingForFinish--;
    if (this.batchesWaitingForFinish == 0) {
      // set coin display to the final value
      G.sb('onCoinsChange').dispatch(G.saveState.getCoins());
    }
  },this);

  batch.start();

};

G.UI_DailyChallengeIcon.prototype._onDailyChallengeIconClick = async function() {
  if (G.featureUnlock.incentiviseDailyChallengeOptIn) {
    let status = await OMT.bots.canSubscribeToBot();
    let optInStatus = G.saveState.getBotOptIn();
    if (status == OMT.bots.CAN_SUBSCRIBE_BOT_FEEDBACK.YES && optInStatus) {  //If suddenly you can opt in again, I need to set this back
      G.saveState.setBotOptIn(false);
      optInStatus = false;
    }
    /**
     * Show opt in if
     * can subscribe says yes
     * can subscribe says no if the person rejected Facebook in that same session
     * it should not show if already is returned
     */
    let showOptIn = !optInStatus && (status != OMT.bots.CAN_SUBSCRIBE_BOT_FEEDBACK.ALREADY);
    // opt-in required before playing the daily challenge
    if (showOptIn) {
      G.sb("pushWindow").dispatch(['dailyChallengeOptIn', this]);
    }
    // no opt-in required open daily challenge
    else {
      this._dailyIconAnotherConsideration();
    }
  }
  else {
    this._dailyIconAnotherConsideration();
  }
}

G.UI_DailyChallengeIcon.prototype._dailyIconAnotherConsideration = function() {
  // console.log("ANOTHER CONSIDERATION ", this.available, OMT.feature.rewardedAdsAvailable());
  if (this.available) {
    let noLife = G.saveState.getLives() === 0 && G.saveState.getUnlimitedLivesSec() === 0;
    if (OMT.feature.rewardedAdsAvailable() || !noLife) {
      G.sb("pushWindow").dispatch(['dailyChallenge',G.saveState.getDailyChallengeLevel()]);
    }
    else if (noLife) {
      G.sb("pushWindow").dispatch(["notEnoughLives"], false, G.WindowMgr.LayerNames.AboveHighScorePanel);
    }
    else {  //Just in case
      G.sb("pushWindow").dispatch(['dailyChallenge',G.saveState.getDailyChallengeLevel()]);
    }
  }
  else if (OMT.feature.rewardedAdsAvailable()) {
    G.sb("pushWindow").dispatch(['dailyChallenge',G.saveState.getDailyChallengeLevel()]);
  }
}
